import {
  CustomizationActiveIngredientsList,
  CustomizationActiveIngredientsStack,
} from './components';

export const CustomizationActiveIngredients = {
  List: CustomizationActiveIngredientsList,
  Stack: CustomizationActiveIngredientsStack,
};
